import React from "react";
import ModalContainer from "../../common/ModalContainer";
import PackageConfirmationBookedTourSection from "./PackageConfirmationBookedTourSection";
import PackageConfirmationTourDetailSection from "./PackageConfirmationTourDetailSection";
import PackageConfirmationTravelerSection from "./PackageConfirmationTravelerSection";

export function PackageOrderDetailsModal({ open, setOpen, booking }) {
  return (
    <ModalContainer open={open} setOpen={setOpen} title="Package order detail">
      <PackageConfirmationBookedTourSection booking={booking} />
      <PackageConfirmationTourDetailSection booking={booking} />
      <PackageConfirmationTravelerSection booking={booking} />
      {/* <div className="w-full flex flex-col" >
        
      </div> */}
    </ModalContainer>
  );
}
